import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { FiLogOut } from "react-icons/fi";
import styles from "./LogoutConfirmModal.module.css";

const LogoutConfirmModal = ({ isOpen, onConfirm, onCancel, loading = false }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.iconWrap}>
            <FiLogOut className={styles.icon} aria-hidden />
          </div>
          <h3 className={styles.title}>{t("logout.title")}</h3>
        </div>

        <p className={styles.message}>{t("logout.message")}</p>

        <div className={styles.actions}>
          <button type="button" onClick={onCancel} className={styles.cancelBtn} disabled={loading}>
            {t("common.cancel")}
          </button>
          <button type="button" onClick={onConfirm} className={styles.logoutBtn} disabled={loading}>
            {loading
              ? t("logout.processing", { defaultValue: "Çıxış edilir..." })
              : t("logout.confirm")}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default LogoutConfirmModal;
